import React, { useState, useEffect } from "react";
import {
  Drawer,
  IconButton,
  Grid,
  Box,
  Typography,
  Divider,
  ButtonBase,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { APPIMAGE_BASE_URL } from "../../config/constants";

const colors = [
  "#FFE5CC", // Light orange
];

const MobileDrawerMenu = ({ mobileOpen, handleDrawerToggle, menuItems }) => {
  const navigate = useNavigate();
  const [currentColorIndex, setCurrentColorIndex] = useState(0);

  // Change color for all tiles every 10 seconds
  useEffect(() => {
    const colorInterval = setInterval(() => {
      setCurrentColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 10000);

    return () => clearInterval(colorInterval);
  }, []);

  return (
    <Drawer
      anchor="left"
      open={mobileOpen}
      onClose={handleDrawerToggle}
      sx={{
        "& .MuiDrawer-paper": {
          width: "80%",
          height: "95%",
          position: "relative", // Allows absolute positioning inside
          borderTopRightRadius: "20px",
          borderBottomLeftRadius: "20px",
          borderBottomRightRadius: "20px",
          paddingTop: "60px", // Space for fixed header
          paddingBottom: "80px", // Space for absolute bottom image
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header Section (Absolute) */}
      <Box
        sx={{
          position: "absolute",
          top: 10,
          left: 0,
          width: "100%",
          padding: "12px 16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "white",
          zIndex: 10,
        }}
      >
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          Shop by category
        </Typography>
      </Box>

      {/* Category Tiles */}
      <Box
        sx={{
          flexGrow: 1,
          overflowY: "auto",
          paddingX: "16px",
          marginTop: "10px",
        }}
      >
        <Grid container spacing={2}>
          {menuItems.map((item, index) => (
            <Grid item xs={6} key={index}>
              <ButtonBase
                onClick={() => {
                  window.location.href = item.href;
                  handleDrawerToggle();
                }}
                sx={{
                  width: "100%",
                  backgroundColor: colors[currentColorIndex], // Changes color every 10 sec
                  color: "#000",
                  fontSize: "20px",
                  fontWeight: "bold",
                  padding: "7px",
                  textAlign: "center",
                  borderRadius: "12px",
                  border: "2px solid #ccc",
                  cursor: "pointer",
                  transition: "background 0.5s ease-in-out",
                  "&:hover": {
                    filter: "brightness(1.2)",
                    transform: "scale(1.05)",
                  },
                }}
              >
                <Typography
                  sx={{ textTransform: "uppercase", letterSpacing: "1px" }}
                >
                  {item.text}
                </Typography>
              </ButtonBase>
            </Grid>
          ))}
          <Grid item xs={12}>
            <ButtonBase
              onClick={() => {
                window.location.href = "/jewels/list/holiday";
                handleDrawerToggle();
              }}
              sx={{
                width: "100%",
                backgroundColor: colors[currentColorIndex], // Changes color every 10 sec
                color: "#000",
                fontSize: "20px",
                fontWeight: "bold",
                padding: "10px",
                textAlign: "center",
                borderRadius: "12px",
                border: "2px solid #ccc",
                cursor: "pointer",
                transition: "background 0.5s ease-in-out",
                "&:hover": {
                  filter: "brightness(1.2)",
                  transform: "scale(1.05)",
                },
              }}
            >
              <Typography
                sx={{ textTransform: "uppercase", letterSpacing: "1px" }}
              >
                Holiday Sale
              </Typography>
            </ButtonBase>
          </Grid>
          <Grid item xs={12}>
            <ButtonBase
              onClick={() => {
                window.location.href = "/jewels/list/clearance";
                handleDrawerToggle();
              }}
              sx={{
                width: "100%",
                backgroundColor: colors[currentColorIndex], // Changes color every 10 sec
                color: "#000",
                fontSize: "20px",
                fontWeight: "bold",
                padding: "10px",
                textAlign: "center",
                borderRadius: "12px",
                border: "2px solid #ccc",
                cursor: "pointer",
                transition: "background 0.5s ease-in-out",
                "&:hover": {
                  filter: "brightness(1.2)",
                  transform: "scale(1.05)",
                },
              }}
            >
              <Typography
                sx={{ textTransform: "uppercase", letterSpacing: "1px" }}
              >
                Clearance Sale
              </Typography>
            </ButtonBase>
          </Grid>
        </Grid>
      </Box>

      {/* Bottom Absolute Image Box */}
      <Box
        sx={{
          position: "absolute",
          bottom: 50,
          left: 0,
          width: "100%",
          height: "100px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={`${APPIMAGE_BASE_URL}/appimages/collection.png`}
          alt="Promo"
          style={{ width: "70%", objectFit: "contain" }}
        />
      </Box>
    </Drawer>
  );
};

export default MobileDrawerMenu;
